<template>
  <el-card class="report-item-funnel">
    <div>
      <div class="title">
        <div class="title-header">
          <span>
            <span v-if="option.title">{{ option.title }}</span>
            <template v-if="option.tooltip">
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content">
                  <div v-html="option.tooltip"></div>
                </div>
                <i class="icon-a-01wenhao iconfont-el icon"></i>
              </el-tooltip>
            </template>
          </span>
          <template v-if="option.link">
            <a :href="option.link">{{ option.linkName }}</a>
          </template>
          <div class="filter-select-wrap">
            <span v-if="option.otherTip" style="margin-right: 5px">{{ option.otherTip }}</span>
            <el-select
              class="filter-select"
              v-if="option.filterParam"
              v-model="option.filter"
              :placeholder="option.filterPlaceholder ? option.filterPlaceholder : '请选择'"
              @change="handleFilter"
            >
              <el-option
                v-for="item in option.filterOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="option.tip" class="tip">{{ option.tip }}</div>
        <slot name="other" :option="option"></slot>
      </div>
      <div class="table-box" :style="`width: 100%;height:${option.height};overflow:hidden;position:relative;`">
        <div class="header-content">
          <div class="item" v-for="item in option.columns" :key="item.id">{{ item.label }}</div>
        </div>

        <div class="cotent-info">
          <div class="info-item" v-for="(item, index) in option.tableData" :key="index">
            <slot name="row" :item="item" :index="index"></slot>
            <div class="before-item"></div>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
export default {
  name: 'itemTable',
  props: {
    config: {
      default: () => {},
    },
  },
  watch: {
    config: {
      handler: function (config) {
        this.option = {
          ...this.option,
          ...config,
        }
      },
      immediate: true,
      deep: true,
    },
  },

  data() {
    return {
      resize: null,
      charts: null,
      option: {
        columns: [],
        tableData: [],
        // title: '默认标题',
        // ref: 'chartBox',
        // height: '400px'
      },
    }
  },
  methods: {
    handleFilter(value) {
      this.$emit('change', value)
    },
  },
}
</script>
<style lang="scss">
.report-item-funnel {
  margin-top: 18px;
  .table-box {
    position: relative;
    .header-content {
      color: #666666;
      display: flex;
      .item {
        flex: 1;
        text-align: center;
      }
    }

    .info-item {
      display: flex;
      margin-top: 20px;
      position: relative;
      &:first-child {
        margin-top: 10px;
      }
      .after-item {
        display: block;
        position: absolute;
        left: 57%;
        top: -83%;
        width: 60px;
        height: 30px;
        font-size: 13px;
        padding-top: 12px;
        text-align: center;
        background-color: #0560fd;
        z-index: 2;
        box-sizing: border-box;
        color: #fff;
      }
      .before-item {
        display: block;
        position: absolute;
        border-top: 20px solid #0560fd;
        border-right: 30px solid transparent;
        border-left: 30px solid transparent;
        left: 57%;
        z-index: 3;
        top: 156%;
      }
      &:last-child {
        // .after-item {
        //   display: none;
        // }
        .before-item {
          display: none;
        }
      }
      .item {
        align-items: center;
        justify-content: center;
        height: 36px;
        display: flex;
        background-color: #edf3ff;
        flex: 1;
        text-align: center;
      }
    }
  }
  .icon {
    color: $--color-info;
    margin-left: 5px;
  }
  .tip {
    margin-top: 4px;
    font-size: 12px;
    color: #9da1c3;
  }
  .title {
    margin-bottom: 24px;
    position: relative;
    .filter-select-wrap {
      flex: 1;
      text-align: end;
    }
    .filter-select {
      width: 150px;
    }
  }
  .title-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .info-rate {
    position: relative;
    top: -28px;
    .rata {
      font-size: 14px;
      color: #00ce47;
      &.t {
        color: #ff0022;
      }
    }
  }
}
</style>
